import { Link } from 'react-router-dom';
import type { topics } from '@/mocks/topics';

type Topic = (typeof topics)[number];

interface TopicCardProps {
  topic: Topic;
}

export default function TopicCard({ topic }: TopicCardProps) {
  return (
    <article className="h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col hover:border-primary-300 transition-colors group">
      <Link to={`/topics/${topic.id}`} className="cursor-pointer block">
        <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
          <img
            src={topic.image}
            alt={`${topic.title}配图`}
            title={`${topic.title} · 爆料专区话题`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-foreground-800 text-xs whitespace-nowrap">
            {topic.categoryName}
          </span>
        </div>
      </Link>
      <div className="p-5 md:p-6 flex-1 flex flex-col">
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span>{topic.date}</span>
          <span>·</span>
          <span>{topic.reading}</span>
        </div>
        <h3 className="font-heading mt-2.5 text-base md:text-lg font-semibold text-foreground-950 leading-snug">
          <Link to={`/topics/${topic.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 flex-1">{topic.summary}</p>
        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
          <span className="text-xs text-foreground-500 truncate">{topic.author}</span>
          <span className="inline-flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap shrink-0">
            <i className="ri-fire-line" />
            {topic.hot.toLocaleString()}
          </span>
        </div>
      </div>
    </article>
  );
}